import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import ModalSearchClient from 'pages/parts/ModalSearchClient'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'
import { renderSortIndicator } from 'helpers/tableSortIndicator'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'

import Rightbar from './Rightbar'
import { httpOk, GET, FILE_D } from 'helpers/api'
import { formatDate, returnSign, formatMoney, findKeyFromArrayByValue, PAGE_SIZES } from 'helpers/helpers'
import CustomTooltip from "pages/parts/CustomTooltip"
import { businessNow, businessDayStartOf, businessDayEndOf } from 'helpers/businessDay'

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const statuses = [
		{ 'id': 1, 'name': t('open') },
		{ 'id': 10, 'name': t('closed') },
		{ 'id': -1, 'name': t('deleted') },
	]

	const productStatuses = [
		{ 'id': 10, 'name': t('success') },
		{ 'id': -1, 'name': t('deleted') },
	]

	const chequeOptions = [
		{ 'id': 'with_delivery', 'name': t('with_delivery_price') },
		{ 'id': 'without_delivery', 'name': t('without_delivery_price') },
		{ 'id': 'with_client', 'name': t('with_delivery') },
		{ 'id': 'without_client', 'name': t('without_delivery') },
	]

	const orderTypes = [
		{ "id": 1, "name": t('hall') },
		{ "id": 2, "name": t('takeaway') },
		{ "id": 3, "name": t('delivery') },
	]

	const [menu, setMenu] = useState([])
	const [poses, setPoses] = useState([])
	const [shifts, setShifts] = useState([])
	const [halls, setHalls] = useState([])
	const [waiters, setWaiters] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [couriers, setCouriers] = useState([])
	const [operators, setOperators] = useState([])
	const [orderSubTypes, setOrderSubTypes] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [discountServices, setDiscountServices] = useState([])
	const [clients, setClients] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [modalSearchClient, setModalSearchClient] = useState(false)
	const [showRightBar, setShowRightBar] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [showMoreFilters, setShowMoreFilters] = useState(false)
	const {
		filterData,
		setFilterData,
		appliedFilterData,
		setAppliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
	} = useFilterSearchPagination({
		initialFilterData: (() => {
			// Сегодня — операционный день точки: при начале дня 03:00 это 03:00 … 02:59 следующего дня
			const now = businessNow()
			const startOfDay = businessDayStartOf(now)
			const endOfDay = businessDayEndOf(now)
			return {
				start_date: formatDate(startOfDay, 'yyyy-MM-dd HH:mm:ss'),
				end_date: formatDate(endOfDay, 'yyyy-MM-dd HH:mm:ss'),
				pos_id: reduxAccount.pos_id,
				status: 10,
				search: '',
				size: 20,
				filter_type: 'day',
				shift_id: '',
			}
		})(),
		initialPagination: {
			url: '/cheques',
			size: 20,
			response: null
		},
	})
	const [data, setData] = useState([])

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		var filterUrl = "/cheques"
		var urlParams = ""
		checkFilter(filterDataCopy)

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.id)
			urlParams += returnSign(urlParams) + 'id=' + filterDataCopy.id
		if (filterDataCopy.cheque_option)
			urlParams += returnSign(urlParams) + 'cheque_option=' + filterDataCopy.cheque_option
		if (filterDataCopy.cheque_number)
			urlParams += returnSign(urlParams) + 'cheque_number=' + filterDataCopy.cheque_number
		if (filterDataCopy.order_by)
			urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by
		if (filterDataCopy.menu_id)
			urlParams += returnSign(urlParams) + 'menu_id=' + filterDataCopy.menu_id
		if (filterDataCopy.client_id)
			urlParams += returnSign(urlParams) + 'client_id=' + filterDataCopy.client_id
		if (filterDataCopy.cashier_login)
			urlParams += returnSign(urlParams) + 'cashier_login=' + filterDataCopy.cashier_login
		if (filterDataCopy.waiter_login)
			urlParams += returnSign(urlParams) + 'waiter_login=' + filterDataCopy.waiter_login
		if (filterDataCopy.operator_login)
			urlParams += returnSign(urlParams) + 'operator_login=' + filterDataCopy.operator_login
		if (filterDataCopy.courier_login)
			urlParams += returnSign(urlParams) + 'courier_login=' + filterDataCopy.courier_login

		if (filterDataCopy.order_type_ids && filterDataCopy.order_type_ids.length > 0) {
			const ids = filterDataCopy.order_type_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'order_type_ids=' + ids;
		}
		if (filterDataCopy.order_type_sub_ids && filterDataCopy.order_type_sub_ids.length > 0) {
			const ids = filterDataCopy.order_type_sub_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'order_type_sub_ids=' + ids;
		}
		if (filterDataCopy.payment_type_ids && filterDataCopy.payment_type_ids.length > 0) {
			const ids = filterDataCopy.payment_type_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'payment_type_ids=' + ids;
		}
		if (filterDataCopy.discount_service_ids && filterDataCopy.discount_service_ids.length > 0) {
			const ids = filterDataCopy.discount_service_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'discount_service_ids=' + ids;
		}

		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.product_status)
			urlParams += returnSign(urlParams) + 'product_status=' + filterDataCopy.product_status
		urlParams += returnSign(urlParams) + 'mode=' + (filterDataCopy.filter_type || 'day')
		if (filterDataCopy.filter_type === 'shift' && filterDataCopy.shift_id)
			urlParams += returnSign(urlParams) + 'shift_id=' + filterDataCopy.shift_id
		if (filterDataCopy.courier_id)
			urlParams += returnSign(urlParams) + 'courier_id=' + filterDataCopy.courier_id
		if (filterDataCopy.hall_id)
			urlParams += returnSign(urlParams) + 'hall_id=' + filterDataCopy.hall_id
		if (filterDataCopy.cheque_type)
			urlParams += returnSign(urlParams) + 'cheque_type=' + filterDataCopy.cheque_type
		if (filterDataCopy.filter_type !== 'shift' && filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.filter_type !== 'shift' && filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (passedData['excel']) {
			urlParams += returnSign(urlParams) + 'excel=true'

			const responseExcel = await FILE_D(filterUrl + urlParams)
			if (httpOk(responseExcel)) {
				// Создаем объект Blob из полученного файла
				const file = new Blob([responseExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Создаем ссылку для скачивания файла
				const fileUrl = URL.createObjectURL(file);

				// Создаем ссылку для скачивания файла в браузере
				const link = document.createElement('a');
				link.href = fileUrl;
				link.setAttribute('download', `cheques.xlsx`);
				document.body.appendChild(link);
				link.click();

				// Удаляем ссылку после скачивания файла
				URL.revokeObjectURL(fileUrl);
			}
			return
		}

		filterDataCopy.urlParams = urlParams

		if (`/cheques${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		if (filterDataCopy.sort) {
			if (filterDataCopy.tableSortKey === filterDataCopy.sort) {
				filterDataCopy.tableSortDirection === ',asc' ? filterDataCopy.tableSortDirection = ',desc' : filterDataCopy.tableSortDirection = ',asc'
			} else {
				filterDataCopy.tableSortDirection = ',asc'
			}
			filterDataCopy.tableSortKey = filterDataCopy.sort
			urlParams += returnSign(urlParams) + 'sort=' + filterDataCopy.sort + filterDataCopy.tableSortDirection
		}

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setAppliedFilterData(filterDataCopy)
			setPagination({ ...pagination, 'url': filterUrl, 'size': filterDataCopy.size, 'response': response.data })
		}
		setDropdownIsOpen(false)
	}

	async function chequeTotals() {
		var dataCopy = { ...data }

		const response = await GET(`/cheques-details${appliedFilterData.urlParams || filterData.urlParams || ''}`, {}, { loader: true })
		if (httpOk(response)) {
			dataCopy.total_hall = response.data.total_hall
			dataCopy.total_takeaway = response.data.total_takeaway
			dataCopy.total_delivery = response.data.total_delivery
			dataCopy.total_delivery_manager = response.data.total_delivery_manager
			dataCopy.total_delivery_telegram = response.data.total_delivery_telegram
			dataCopy.total_delivery_call_center = response.data.total_delivery_call_center
			dataCopy.total_people_number = response.data.total_people_number
			dataCopy.total_deleted = response.data.total_deleted
			dataCopy.total_discount = response.data.total_discount
			dataCopy.total_delivery_price = response.data.total_delivery_price
			setData(dataCopy)
			setShowModal(true)
		}
	}

	async function toggleRightbar(boolean = false, item, index) {
		var dataCopy = [...data.data]

		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i]['showSidebar'] = false
		}
		if (boolean) {
			const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				dataCopy[index] = response.data.data

				setSelectedItem(dataCopy[index])
				setShowRightBar(boolean)
			}

		} else {
			setShowRightBar(boolean)
			setSelectedItem({})
		}
	}

	async function toggleModalClients(bool = false) {
		setModalSearchClient(bool)
	}

	async function handleSelectClient(payload = {}) {
		patchFilterData({ 'client_id': payload.id })
		toggleModalClients()
		setDropdownIsOpen(true)
	}

	async function handleSelect(option) {
		setShifts([])
		getHalls(option.id)
		getCashiers(option.id)
		getWaiters(option.id)
		getCouriers(option.id)

		patchFilterData({ 'pos_id': option.id, shift_id: '' })
	}

	function handlePaginate(page) {
		paginate(page)
		searchWithFilter({ filterData: { ...filterData, page } })
	}

	function handlePageSizeChange(size) {
		const nextFilterData = { ...filterData, size, page: null }
		patchFilterData({ size, page: null })
		searchWithFilter({ filterData: nextFilterData })
	}

	function resetFilter() {
		const today = businessNow()
		const monthStart = businessDayStartOf(new Date(today.getFullYear(), today.getMonth(), 1))
		const todayEnd = businessDayEndOf(today)
		const nextFilterData = {
			start_date: formatDate(monthStart, 'yyyy-MM-dd HH:mm:ss'),
			end_date: formatDate(todayEnd, 'yyyy-MM-dd HH:mm:ss'),
			pos_id: null,
			status: null,
			search: '',
			size: filterData.size ?? 20,
			cashier_login: null,
			filter_type: 'day',
			shift_id: '',
		}
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	async function checkFilter(currentFilterData) {
		if (
			currentFilterData.pos_id === null &&
			currentFilterData.cashier_login === null &&
			currentFilterData.status === null &&
			currentFilterData.start_date === null &&
			currentFilterData.end_date === null &&
			!currentFilterData.shift_id &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	// Сортировка по заголовку таблицы. Бэкенд ждёт order_by вида 'cheque_number,asc'
	function sortByColumn(column) {
		const [currentColumn, currentSort] = String(filterData.order_by || '').split(',')
		const sort = currentColumn === column && currentSort === 'asc' ? 'desc' : 'asc'
		const nextFilterData = { ...filterData, 'order_by': `${column},${sort}`, 'page': null }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function sortState() {
		const [orderBy, sort] = String(filterData.order_by || '').split(',')
		return { 'order_by': orderBy || null, 'sort': sort }
	}

	function toggleDropdown() {
		// Заполненный редкий фильтр не прячем: при открытии блок «Ещё фильтры» раскрыт
		if (!dropdownIsOpen) setShowMoreFilters(countHiddenFilters() > 0)
		setDropdownIsOpen(!dropdownIsOpen)
	}

	// Сколько фильтров из свёрнутого блока «Ещё фильтры» заполнено
	function countHiddenFilters() {
		return ['id', 'cheque_number', 'product_status', 'menu_id', 'hall_id', 'cheque_option', 'operator_login']
			.filter(key => filterData[key] !== null && filterData[key] !== undefined && filterData[key] !== '')
			.length
	}

	function returnClassStatus(status) {
		if (status === 1) {
			return "bg-primary text-white"
		}
		if (status === 2) {
			return "bg-warning text-white"
		}
		if (status === 3) {
			return "bg-success text-white"
		}
	}

	function changeFilterType(filterType) {
		patchFilterData({
			filter_type: filterType,
			shift_id: filterType === 'day' ? '' : filterData.shift_id,
		})
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getCashiers(pos_id) {
		const response = await GET(`/helper/users-type?pos_id=${pos_id}&type=cashier`)
		if (httpOk(response)) setCashiers(response.data)
	}

	async function getWaiters(pos_id) {
		const response = await GET(`/helper/users-type?pos_id=${pos_id}&type=waiter`)
		if (httpOk(response)) setWaiters(response.data)
	}

	async function getOperators(pos_id) {
		// Операторы на уровне бренда, не фильтруем по торговой точке
		const response = await GET(`/helper/users-type?type=operator&all_positions=1`)
		if (httpOk(response)) setOperators(response.data)
	}

	async function getCouriers(pos_id) {
		const response = await GET(`/helper/users-type?pos_id=${pos_id}&type=courier`)
		if (httpOk(response)) setCouriers(response.data)
	}

	async function getHalls(pos_id) {
		const response = await GET(`/helper/halls?pos_id=${pos_id}`)
		if (httpOk(response)) setHalls(response.data)
	}

	async function getShifts() {
		let filterUrl = "/helper/shifts?limit=20"
		if (filterData.pos_id) {
			filterUrl += `&pos_id=${filterData.pos_id}`
		}
		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setShifts(response.data)
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	async function getOrderSubTypes() {
		const response = await GET('/helper/order-type-subs')
		if (httpOk(response)) setOrderSubTypes(response.data)
	}

	async function getDiscountServices() {
		const response = await GET('/analytics/discount-services')
		if (httpOk(response)) setDiscountServices(response.data)
	}

	async function getMenu() {
		const response = await GET('/helper/menu')
		if (httpOk(response)) setMenu(response.data)
	}

	useEffect(() => {
		getPoses()
		getHalls(reduxAccount.pos_id)
		getCashiers(reduxAccount.pos_id)
		getWaiters(reduxAccount.pos_id)
		getCouriers(reduxAccount.pos_id)
		getOperators(reduxAccount.pos_id)
		getMenu()
		getPaymentTypes()
		getOrderSubTypes()
		getDiscountServices()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex mb-2">
				<h4 className="vertical-center">
					{t('cheques')} [{data?.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter({ filterData: nextFilterData })
									})}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										{/* Период — первым: его меняют чаще всего. День / смена — в строке подписи */}
										<div className="row">
											<div className="form-group col-md-12">
												<div className="d-flex justify-content-between align-items-center">
													<label>{filterData.filter_type === 'shift' ? t('shift') : t('period')}</label>
													<div className="d-flex gap-3">
														<div className="form-check mb-0">
															<input
																className="form-check-input"
																type="checkbox"
																id="cheques-filter-day"
																checked={filterData.filter_type !== 'shift'}
																onChange={() => changeFilterType('day')}
															/>
															<label className="form-check-label" htmlFor="cheques-filter-day">
																{t('day')}
															</label>
														</div>
														<div className="form-check mb-0">
															<input
																className="form-check-input"
																type="checkbox"
																id="cheques-filter-shift"
																checked={filterData.filter_type === 'shift'}
																onChange={() => changeFilterType('shift')}
															/>
															<label className="form-check-label" htmlFor="cheques-filter-shift">
																{t('shift')}
															</label>
														</div>
													</div>
												</div>
												{filterData.filter_type !== 'shift' &&
													<PeriodPicker
														startDate={filterData.start_date}
														endDate={filterData.end_date}
														minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
														maxDate={new Date(new Date().getFullYear(), 11, 31)}
														onChange={(period) => patchFilterData(period)}
													/>
												}
												{filterData.filter_type === 'shift' &&
													<div className="d-flex gap-2">
														<input
															type="text"
															className="form-control"
															placeholder={`${t('shift')} ID`}
															value={filterData.shift_id || ''}
															onChange={(e) => patchFilterData({ 'shift_id': e.target.value })}
														/>
														<button type="button" className="btn btn-outline-primary text-nowrap" onClick={getShifts}>
															{t('load')}
														</button>
													</div>
												}
												{filterData.filter_type === 'shift' && shifts.length > 0 &&
													<div className="mt-2">
														<Select
															options={shifts}
															value={shifts.find(option => String(option.id) === String(filterData.shift_id)) || ''}
															onChange={(option) => patchFilterData({ 'shift_id': option ? option.id : '' })}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => `#${option.id} ${option.pos_name || ''} ${formatDate(option.opened_at, 'dd.MM.yy HH:mm')} - ${option.closed_at ? formatDate(option.closed_at, 'dd.MM.yy HH:mm') : '...'}`}
															getOptionValue={(option) => option.id}
														/>
													</div>
												}
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => handleSelect(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-4">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => patchFilterData({ 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-4">
												<label>{t('payment_types')}</label>
												<Select
													isMulti
													isClearable
													options={paymentTypes}
													value={filterData.payment_type_ids}
													onChange={(options) => patchFilterData({ 'payment_type_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											{/* Сервис скидки: правило кабинета, ручная кассира, агрегатор, промокод */}
											<div className="form-group col-md-4">
												<label>{t('discount_service')}</label>
												<Select
													isMulti
													isClearable
													options={discountServices}
													value={filterData.discount_service_ids}
													onChange={(options) => patchFilterData({ 'discount_service_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => `${option.name} · ${t(`discount_source_${option.source}`)}`}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('order_type')}</label>
												<Select
													isMulti
													isClearable
													options={orderTypes}
													value={filterData.order_type_ids}
													onChange={(options) => patchFilterData({ 'order_type_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-4">
												<label>{t('delivery_type')}</label>
												<Select
													isMulti
													isClearable
													options={orderSubTypes}
													value={filterData.order_type_sub_ids}
													onChange={(options) => patchFilterData({ 'order_type_sub_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-4">
												<label>{t('courier')}</label>
												<Select
													options={couriers}
													value={couriers.find(option => option.login === filterData.courier_login) || ''}
													onChange={(option) => patchFilterData({ 'courier_login': option ? option.login : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.first_name}
													getOptionValue={(option) => option.login}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('cashier')}</label>
												<Select
													isClearable
													options={cashiers}
													value={cashiers.find(option => option.login === filterData.cashier_login) || ''}
													onChange={(option) => patchFilterData({ 'cashier_login': option ? option.login : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.first_name}
													getOptionValue={(option) => option.login}
												/>
											</div>
											<div className="form-group col-md-4">
												<label>{t('waiter')}</label>
												<Select
													isClearable
													options={waiters}
													value={waiters.find(option => option.login === filterData.waiter_login) || ''}
													onChange={(option) => patchFilterData({ 'waiter_login': option ? option.login : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.first_name}
													getOptionValue={(option) => option.login}
												/>
											</div>
											<div className="form-group col-md-4">
												<label>{t('clients')}</label>
												<div className="d-flex gap-1">
													<Select
														className="w-100"
														isClearable
														options={clients}
														value={clients.find(option => option.id === filterData.client_id) || ''}
														onChange={(option) => patchFilterData({ 'client_id': option ? option.id : null })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
													<button className="btn btn-outline-primary btn-wide-2"
														onClick={() => toggleModalClients(true)}>
														<i className="uil uil-search"></i>
													</button>
												</div>
											</div>
										</div>

										{/* Редкие фильтры свёрнуты; заполненный — раскрывает блок при открытии */}
										<button type="button" className="btn btn-link px-0 py-1 text-decoration-none"
											onClick={() => setShowMoreFilters(!showMoreFilters)}>
											<i className={`uil ${showMoreFilters ? 'uil-angle-up' : 'uil-angle-down'} me-1`}></i>
											{showMoreFilters ? t('hide_filters') : t('more_filters')}
											{!showMoreFilters && countHiddenFilters() > 0 &&
												<span className="badge bg-primary ms-2">{countHiddenFilters()}</span>
											}
										</button>
										{showMoreFilters &&
											<>
												<div className="row">
													<div className="form-group col-md-4">
														<label>{t('cheque')} ID</label>
														<input type="text" className="form-control"
															value={filterData.id ?? ''}
															onChange={(e) => patchFilterData({ 'id': e.target.value })} />
													</div>
													<div className="form-group col-md-4">
														<label>{t('cheque')} №</label>
														<input type="text" className="form-control"
															value={filterData.cheque_number ?? ''}
															onChange={(e) => patchFilterData({ 'cheque_number': e.target.value })} />
													</div>
													<div className="form-group col-md-4">
														<label>{t('product')}</label>
														<Select
															isClearable
															options={productStatuses}
															value={productStatuses.find(option => option.id === filterData.product_status) || ''}
															onChange={(option) => patchFilterData({ 'product_status': option ? option.id : null })}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>
													</div>
												</div>
												<div className="row">
													<div className="form-group col-md-4">
														<label>{t('menu')}</label>
														<Select
															options={menu}
															value={menu.find(option => option.id === filterData.menu_id) || ''}
															onChange={(option) => patchFilterData({ 'menu_id': option.id })}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>
													</div>
													<div className="form-group col-md-4">
														<label>{t('halls')}</label>
														<Select
															isClearable
															options={halls}
															value={halls.find(option => option.id === filterData.hall_id) || ''}
															onChange={(option) => patchFilterData({ 'hall_id': option ? option.id : null })}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>
													</div>
													<div className="form-group col-md-4">
														<label>{t('cheques')}</label>
														<Select
															isClearable
															options={chequeOptions}
															value={chequeOptions.find(option => option.id === filterData.cheque_option) || ''}
															onChange={(option) => patchFilterData({ 'cheque_option': option ? option.id : null })}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>
													</div>
												</div>
												<div className="row">
													<div className="form-group col-md-4">
														<label>{t('operators')}</label>
														<Select
															options={operators}
															value={operators.find(option => option.login === filterData.operator_login) || ''}
															onChange={(option) => patchFilterData({ 'operator_login': option ? option.login : null })}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => option.first_name}
															getOptionValue={(option) => option.login}
														/>
													</div>
												</div>
											</>
										}
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter({ filterData: nextFilterData })
														})}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button type="button" className="btn btn-outline-primary btn-wide-2"
									onClick={() => searchWithFilter({ 'excel': true })}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
							<div>
								<button type="button" className="btn btn-outline-primary btn-wide-2"
									onClick={() => chequeTotals()}>
									<CustomTooltip text={t('additional_info')}>
										<i className="uil uil-comment-info"></i>
									</CustomTooltip>
								</button>
							</div>
						</div>
						<div className="vertical-center">
							<h4 className="text-end">
								<b>{t('amount')}</b>: {formatMoney(data.total_cheques_amount)}
							</h4>
							{!!data.deleted_total_amount &&
								<h4 className="text-end">
									<b>{t('deletions_amount')}</b>: {formatMoney(data.deleted_total_amount)}
								</h4>
							}
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{appliedFilterData.filter_type !== 'shift' && (appliedFilterData.start_date || appliedFilterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{appliedFilterData.start_date &&
											<span>{formatDate(appliedFilterData.start_date, 'dd.MM.yy HH:mm')}</span>
										}
										{(appliedFilterData.start_date && appliedFilterData.end_date) &&
											<span>|</span>
										}
										{appliedFilterData.end_date &&
											<span>{formatDate(appliedFilterData.end_date, 'dd.MM.yy HH:mm')}</span>
										}
									</span>
								}
								{appliedFilterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', appliedFilterData.pos_id, 'name')}
									</span>
								}
								{appliedFilterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', appliedFilterData.status, 'name')}
									</span>
								}
								{appliedFilterData.menu_id &&
									<span className="me-2">
										<b>{t('menu')}: </b>
										{findKeyFromArrayByValue(menu, 'id', appliedFilterData.menu_id, 'name')}
									</span>
								}
								{appliedFilterData.cashier_login &&
									<span className="me-2">
										<b>{t('cashier')}: </b>
										{findKeyFromArrayByValue(cashiers, 'login', appliedFilterData.cashier_login, 'first_name')}
									</span>
								}
								{appliedFilterData.courier_login &&
									<span className="me-2">
										<b>{t('courier')}: </b>
										{findKeyFromArrayByValue(couriers, 'login', appliedFilterData.courier_login, 'first_name')}
									</span>
								}
								{appliedFilterData.id &&
									<span className="me-2">
										<b>ID: </b> {appliedFilterData.id}
									</span>
								}
								{appliedFilterData.shift_id &&
									<span className="me-2">
										<b>{t('shift')} ID: </b> {appliedFilterData.shift_id}
									</span>
								}
								{appliedFilterData.hall_id &&
									<span className="me-2">
										<b>{t('hall')}: </b>
										{findKeyFromArrayByValue(halls, 'id', appliedFilterData.hall_id, 'name')}
									</span>
								}
								{appliedFilterData.order_type &&
									<span className="me-2">
										<b>{t('order_type')}: </b>
										{findKeyFromArrayByValue(orderTypes, 'id', appliedFilterData.order_type, 'name')}
									</span>
								}
								{appliedFilterData.order_type_sub_id &&
									<span className="me-2">
										<b>{t('order_type')}: </b>
										{findKeyFromArrayByValue(orderSubTypes, 'id', appliedFilterData.order_type_sub_id, 'name')}
									</span>
								}
								{appliedFilterData.payment_type_id &&
									<span className="me-2">
										<b>{t('payment_type')}: </b>
										{findKeyFromArrayByValue(paymentTypes, 'id', appliedFilterData.payment_type_id, 'name')}
									</span>
								}
								{appliedFilterData.discount_service_ids && appliedFilterData.discount_service_ids.length > 0 &&
									<span className="me-2">
										<b>{t('discount_service')}: </b>
										{appliedFilterData.discount_service_ids.map(item => item.name).join(', ')}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={() => resetFilter()}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('pos')}</th>
									<th style={{ 'width': '10%' }}>{t('cashier')}</th>
									<th style={{ 'width': '10%' }}>{t('waiter')}</th>
									<th style={{ 'width': '5%' }} className="text-center text-nowrap th-sortable user-select-none"
										title={t('sort_by')}
										onClick={() => sortByColumn('cheque_number')}>
										<div className="d-flex align-items-center justify-content-center gap-1">
											<span>{t('cheque')} №</span>
											{renderSortIndicator('cheque_number', sortState())}
										</div>
									</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('hall')}</th>
									<th style={{ 'width': '5%' }}>{t('table')}</th>
									<th style={{ 'width': '5%' }} className="text-center">{t('guests')}</th>
									<th style={{ 'width': '10%' }}>{t('counterparty')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-center">{t('open_date')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-center">{t('close_date')}</th>
									<th style={{ 'width': '10%' }} className="text-end th-sortable user-select-none"
										title={t('sort_by')}
										onClick={() => sortByColumn('total_amount_service')}>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('amount')}</span>
											{renderSortIndicator('total_amount_service', sortState())}
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr className={`cursor ${item.showSidebar ? 'table-tr-active' : ''}`} key={index}>
										<td className="text-center" title={item.id}>
											{item.row_number}
										</td>
										<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
											{item.pos_short_name}
										</td>
										<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
											{item.cashier_first_name}
										</td>
										<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
											{item.waiter_first_name}
										</td>
										<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
											{item.cheque_number}
										</td>
										<td className={`text-center ${returnClassStatus(item.order_type)}`}
											onClick={() => toggleRightbar(true, item, index)}>
											{item.order_type === 1 &&
												<span>{t('hall')}</span>
											}
											{item.order_type === 2 &&
												<span>{t('takeaway')}</span>
											}
											{item.order_type === 3 &&
												<span>{t('delivery')}</span>
											}
										</td>
										<td onClick={() => toggleRightbar(true, item, index)}>
											{item.hall_name}
										</td>
										<td onClick={() => toggleRightbar(true, item, index)}>
											{item.table_name}
										</td>
										<td className="text-center" onClick={() => toggleRightbar(true, item, index)}>
											{item.people_number}
										</td>
										<td className="td-ellipsis" onClick={() => toggleRightbar(true, item, index)}>
											{item.entity_name}
										</td>
										<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
											{formatDate(item.cheque_opened_at, 'dd.MM.yy HH:mm')}
										</td>
										<td onClick={() => toggleRightbar(true, item, index)} className="text-center">
											{formatDate(item.cheque_closed_at, 'dd.MM.yy HH:mm')}
										</td>
										<td className={`text-end text-nowrap ${item.entity_debtor_id ? 'bg-danger text-white' : ''}`}
											onClick={() => toggleRightbar(true, item, index)}>
											{formatMoney(item.total_amount_service)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}
							showPageSizeSelect
							pageSizeOptions={PAGE_SIZES}
							onPageSizeChange={handlePageSizeChange}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL ADDITIONAL INFO */}
			<Modal
				show={showModal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('additional_info')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('guests')}</span>
						<span>{formatMoney(data.total_people_number)}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')}</span>
						<span>{formatMoney(data.total)}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('hall')} ]</span>
						<span>{formatMoney(data.total_hall)}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
						<span>{formatMoney(data.total_takeaway)}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
						<span>{formatMoney(data.total_delivery)}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('deleted')} ]</span>
						<span>{formatMoney(data.total_deleted)}</span>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL ADDITIONAL INFO */}

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				selectedItem={selectedItem}>
			</Rightbar>

			{modalSearchClient &&
				<ModalSearchClient
					setClients={setClients}
					modalSearchClient={modalSearchClient}
					handleSelectClient={handleSelectClient}
					toggleModalClients={toggleModalClients}>
				</ModalSearchClient>
			}
		</>
	)
}

export default Index
